package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.request_model.AddServiceRequest
import kz.dentalcrm.app.data.network.request_model.Name
import kz.dentalcrm.app.data.network.response_model.services.ServicesResponse
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

class ServicesApi(
    private val httpClient: HttpClient,
    private val storage: Storage
) {

    suspend fun getServiceCategories() = httpClient.handle<List<ServiceCategory>?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/service_categories"
            )
        }
        method = HttpMethod.Get
    }

    suspend fun addServiceCategory(
        name: String
    ) = httpClient.handle<ServiceCategory?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/service_categories"
            )
            setBody(
                Name(
                    name = name
                )
            )
        }
        method = HttpMethod.Post
    }

    suspend fun updateServiceCategory(
        id: Int,
        name: String,
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/service_categories/$id"
            )
        }
        setBody(
            Name(
                name = name,
                id = id
            )
        )
        method = HttpMethod.Put
    }

    suspend fun deleteServiceCategory(
        id: String
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/service_categories/$id"
            )
        }
        method = HttpMethod.Delete
    }

    suspend fun addService(
        request: AddServiceRequest
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/services"
            )
            setBody(request)
        }
        method = HttpMethod.Post
    }

    suspend fun editService(
        request: AddServiceRequest,
        id: Int
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/services/${id}"
            )
            setBody(request)
        }
        method = HttpMethod.Put
    }

    suspend fun deleteService(
        id: Int
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/services/${id}"
            )
        }
        method = HttpMethod.Delete
    }

    suspend fun getServices(
        page: Int = 1,
        perPage: Int = 10,
        category: String = "",
        search: String = "",
    ) = httpClient.handle<ServicesResponse?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/services"
            )
            parameters.append("page", page.toString())
            parameters.append("perPage", perPage.toString())
            if (search.isNotEmpty()) {
                parameters.append("search", search)
            }
            if (category.isNotEmpty()) {
                parameters.append("category_id", category)
            }
        }
        method = HttpMethod.Get
    }
}
